import React, { useContext, useState } from 'react';
import ModalModule from '../modal';
import UI from '../ui';

const { WrappedCheckbox } = UI;

const { Modal, ModalContext, ModalButtonActionType } = ModalModule;

const MessageModalWithCheckbox = props => {
	const {
		modalId,
		data: {
			title,
			description,
			checkboxLabel,
			dataqa = 'common-modal',
			checkboxValue,
			closeCallback,
		},
	} = props;
	const { closeModal } = useContext(ModalContext);
	const [_checkboxValue, setCheckboxValue] = useState(!!checkboxValue);

	const onChange = ({ checked }) => {
		setCheckboxValue(checked);
	};

	const onPrimaryButtonClick = () => {
		if (closeCallback) {
			closeCallback({
				checkboxValue: _checkboxValue,
				actionType: ModalButtonActionType.Ok,
			});
		}
		closeModal(modalId, ModalButtonActionType.Ok);
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Got It',
		onClick: onPrimaryButtonClick,
		dataqa: 'message-modal-got-it-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="common-branded-tracking-live-modal"
			header={title}
			primaryButton={primaryButton}
		>
			<div className="body">
				<div
					className="message-modal-body-description"
					data-qa="message-modal-desc"
					{...{ dataqa: 'message-modal-desc' }}
				>
					{description}
				</div>
				<WrappedCheckbox
					value={_checkboxValue}
					onChange={onChange}
					checked={_checkboxValue}
					dataqa={dataqa}
				>
					{checkboxLabel}
				</WrappedCheckbox>
			</div>
		</Modal>
	);
};

export default MessageModalWithCheckbox;
